export default {
  notifications: {
    title: "Avisos",
    markingAll: "Marcando…",
    markAllRead: "Marcar todo como leído",
    loading: "Cargando…",
    empty: "No tienes avisos.",
    clickToMark: "Clic para marcar como leído",
    now: "Ahora mismo",
    minutesAgo: "Hace {n} min",
    hourAgo: "Hace {n} hora",
    hoursAgo: "Hace {n} horas",
    yesterday: "Ayer",
    daysAgo: "Hace {n} días",
    dateLocale: "es-ES",
  },
};
